var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44414 10.8793L5.76964 5.93812L13.4709 13.2932L8.29717 14.5591L8.27003 14.5658L8.25023 14.5847L7.41054 15.3866L7.33822 15.4557L7.41054 15.5248L9.98987 17.9882L9.12688 18.8124L6.54755 16.349L6.47523 16.2799L6.40291 16.349L5.22735 17.4717C4.96611 17.7212 4.65711 17.8455 4.29523 17.8478C3.93342 17.8501 3.62693 17.7298 3.36999 17.4844L1.38125 15.585C1.12431 15.3396 0.998352 15.0469 1.00075 14.7014C1.00314 14.3557 1.13327 14.0606 1.39451 13.8111L4.41739 10.9241L4.43719 10.9052L4.44414 10.8793ZM2.24424 14.6227L2.17193 14.6918L2.24424 14.7608L4.23298 16.6602L4.3053 16.7292L4.37761 16.6602L7.64949 13.5354L10.9313 12.7245L11.1045 12.6817L10.978 12.5608L6.5365 8.31893L6.40998 8.1981L6.36517 8.36353L5.51611 11.4979L2.24424 14.6227ZM12.8667 5.70357L15.2411 3.43586L16.0909 4.2474L13.7164 6.51512L12.8667 5.70357ZM19.0841 9.21587L19.2473 10.3594L15.9259 10.846L15.7627 9.70245L19.0841 9.21587ZM10.0395 0.5773L9.56253 3.6853L8.36514 3.52936L8.84216 0.421358L10.0395 0.5773ZM12.4915 10.7985L8.38175 6.87344C8.85767 6.8698 9.33362 6.94665 9.81006 7.10461C10.3604 7.28705 10.8568 7.58883 11.2996 8.01177C11.7425 8.43471 12.0585 8.90881 12.2495 9.43439C12.4149 9.88942 12.4953 10.344 12.4915 10.7985Z",
    fill: "#005068",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.724e27e415059979eb0504fe0488b039.svg";
export { ForwardRef as ReactComponent };